<template>
  <div>
    <div class="grid">
      <div class="grid-title">
        <div class="row">
          <div class="col-md-6">
            <h4>Fabric Availability Override</h4>
          </div>
          <div class="col-md-6 text-right">
            <button
              class="btn btn-default"
              :class="{
                'btn-primary': showOverrideUI && !showAlwaysAvailableUI,
              }"
              @click="showAvailabilityOverrides"
            >
              Stock and pieces Overridden
            </button>
            <button
              class="btn btn-default"
              :class="{
                'btn-primary': showOverrideUI && showAlwaysAvailableUI,
              }"
              @click="showAlwaysAvailableFabrics"
            >
              Always Overridden
            </button>
          </div>
        </div>
      </div>

      <FabricAvailabilityOverrideAlways v-if="showAlwaysAvailableUI" />
      <FabricAvailabilityOverridePieces v-if="!showAlwaysAvailableUI" />

      <FabricLowStock />
    </div>
  </div>
</template>
<script>
import FabricAvailabilityOverrideAlways from "./components/FabricAvailabilityOverrideAlways";
import FabricAvailabilityOverridePieces from "./components/FabricAvailabilityOverridePieces";
import FabricLowStock from "./components/FabricLowStock";
export default {
  components: {
    FabricAvailabilityOverrideAlways,
    FabricAvailabilityOverridePieces,
    FabricLowStock
  },
  data() {
    return {
      showAlwaysAvailableUI: false,
      showOverrideUI: false,
    };
  },
  methods: {
    showAlwaysAvailableFabrics() {
      this.showAlwaysAvailableUI = true;
      this.showOverrideUI = true;
    },
    showAvailabilityOverrides() {
      this.showAlwaysAvailableUI = false;
      this.showOverrideUI = true;
    },
    showCreateOverrideDialog() {},
  },
};
</script>
